import axios from 'axios';
import settings from './settings';

// Cliente dedicado a klazia-worker (Klazia Studio). Es un servicio distinto
// a klazia-api/Strapi — sin prefijo /api, con sus propias rutas /jobs.
const workerXhr = axios.create({
	baseURL: settings.workerApi,
});

export default workerXhr;
